import React, { useState } from 'react';
import {
  Button,
} from '@material-ui/core';

import Dialog from '../../ui/Dialog';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay.component';
import { deleteCycle } from '../../../services/transaction.service';

const DeleteCycle = ({ data }) => {
  const { program_id, transaction_code_id } = data;

  const [state, setState] = useState({
    openConfirmation: false,
    openDeleteCycleConfirmation: true,
    modalTitle: 'Delete Cycle',
    errorMessage: null,
    successMessage: 'Cycle has been deleted!',
    isLoading: false,
    latestMessage: '',
    messageLogId: null,
    submitButtonEnabled: false,
  });

  const handleClose = () => {
    const { openConfirmation } = state;
    setState(prev => ({
      ...prev,
      openConfirmation: false,
      openDeleteCycleConfirmation: false,
      errorMessage: null
    }));

    if (openConfirmation) {
      window.location.reload();
    }
  };

  const onDeleteCycle = async () => {
    setState(prev => ({ ...prev, isLoading: true }));

    try {
      const response = await deleteCycle({
        program_id,
        transaction_code_id,
      });
      
      setState(prev => ({
        ...prev,
        openDeleteCycleConfirmation: false,
        successMessage: response.message,
      }));
    } catch (e) {
      setState(prev => ({
        ...prev,
        errorMessage: e.message
      }));
    } finally {
      setState(prev => ({ ...prev, isLoading: false, openDeleteCycleConfirmation: false, openConfirmation: true }));
    }
  };

  const {
    openConfirmation,
    modalTitle,
    errorMessage,
    successMessage,
    isLoading,
    openDeleteCycleConfirmation
  } = state;

  if (isLoading) return <LoadingOverlay />;

  const formButtons = (
    <>
      <Button onClick={handleClose} variant="contained">
        {openConfirmation ? 'OK' : 'Close'}
      </Button>
      {
        openDeleteCycleConfirmation && 
        <Button
          onClick={onDeleteCycle}
          variant="contained"
          color="primary"
          disabled={false}
        >
          Delete
        </Button>
      }
    </>
  );

  return (
    <>
      <Dialog
        key="delete-cycle"
        open={openDeleteCycleConfirmation}
        title={modalTitle}
        content={`Are you sure to delete the cycle?`}
        children={formButtons}
        onSubmit={onDeleteCycle}
        onClose={handleClose}
      />
      <Dialog 
        onSubmit={handleClose}
        key="confirmation"
        open={openConfirmation}
        title='Delete Cycle'
        content={errorMessage || successMessage}
        children={formButtons}
        onClose={handleClose}
      />
      <Button variant="contained" color="primary" onClick={() => {
         setState(prev => ({
          ...prev,
          openValidateConfirmation: true,
        }));
      }} style={{ marginRight: 8 }}>
        Cancel
      </Button>
    </>
  );
};

export default DeleteCycle;